export default "<payment-partners\n  model=\"vm.model.ignorePaymentPartnerList\"\n  form=\"vm.form\">\n</payment-partners>\n";